import { RequiredLegend } from 'enrollment/features/Shared/RequiredLegend/RequiredLegend';

export interface QuestionnaireFormProps {
  children?: JSX.Element | JSX.Element[];
}

export const QuestionnaireForm = ({ children }: QuestionnaireFormProps) => {
  return (
    <div className="questionnaire-form">
      <RequiredLegend />
      <form
        name="questionnaire-form"
        id="questionnaire-form"
        data-testid="questionnaire-form"
        autoComplete="off"
      >
        {children ? children : <></>}
      </form>
    </div>
  );
};
